export default __webpack_public_path__ + "static/media/schedule-6.e98b132a.svg";